import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

function pageWidth() {
  if (typeof window === 'undefined') return 780;
  return Math.min(window.innerWidth - 32, 780);
}

function DocumentPdfView({ fileUrl, title }) {
  const [numPages, setNumPages] = useState(0);

  return (
    <div className="document-view-pdf">
      <Document
        file={fileUrl}
        onLoadSuccess={({ numPages: n }) => setNumPages(n)}
        loading={<div className="empty" style={{ padding: 24 }}>Loading PDF…</div>}
        error={<div className="empty" style={{ padding: 24, color: 'var(--red)' }}>Could not load PDF</div>}
      >
        {Array.from({ length: numPages }, (_, i) => (
          <Page
            key={`page-${i + 1}`}
            pageNumber={i + 1}
            width={pageWidth()}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        ))}
      </Document>
    </div>
  );
}

export { DocumentPdfView };
